<template>
  <div :class="{ 'wordlike' : company === 'none', 'pop' : company !== 'none'}">
    <p class="top" v-if="company !== 'none'">
      Word sponsored by
      <a :href="link" class="link">{{company}}</a>
    </p>
    <a :href="link" class="contain">
      <div class="visual" v-if="company !== 'none'">
        <img :src="logo" class="logo" alt="logo" />
      </div>
      <div class="content">
        <p class="title">{{title}}</p>
        <p class="subtitle">{{subtitle}}</p>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    company: String,
    link: String,
    logo: String,
    title: String,
    subtitle: String
  }
};
</script>

<style scoped>
.pop {
  position: absolute;
  bottom: 10px;
  width: 100vw;
  transition: all 0.25s cubic-bezier(0.075, 0.82, 0.165, 1);
  opacity: 0.75;
}
.pop:hover {
  bottom: 15px;
  opacity: 1;
}
.wordlike {
  position: absolute;
  bottom: 10px;
  width: 100vw;
  transition: all 0.25s cubic-bezier(0.075, 0.82, 0.165, 1);
  opacity: 0.75;
  text-align: center;
}
.wordlike:hover {
  bottom: 15px;
  opacity: 1;
}
.wordlike .contain {
  max-width: 390px;
  align-content: center;
}
.wordlike .content {
  width: 100%;
}
.wordlike .content .title {
  font-size: 16px;
  font-weight: 600;
}
.top {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 150%;
  color: var(--text);
  margin-bottom: 5px;
  opacity: 0.8;
  text-align: center;
  width: 100%;
}
.link {
  color: var(--text);
  transition: all 0.25s cubic-bezier(0.075, 0.82, 0.165, 1);
  font-weight: 500;
  border-bottom: 1px dashed var(--text);
  text-decoration: none;
}

.link:hover {
  opacity: 1;
  font-weight: 700;
  text-decoration: none;
}
.link::after {
  content: "";
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-left: 4px;
  background-color: var(--text);
  -webkit-mask: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25"><path fill-rule="evenodd" clip-rule="evenodd" d="M23.775 0.774994L23.7749 20.8251L20.7749 20.8251L20.775 5.89634L2.33568 24.3357L0.214355 22.2143L18.6537 3.77501L3.72494 3.77507L3.72493 0.775069L23.775 0.774994Z"/></svg>') no-repeat center / contain;
  mask: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25"><path fill-rule="evenodd" clip-rule="evenodd" d="M23.775 0.774994L23.7749 20.8251L20.7749 20.8251L20.775 5.89634L2.33568 24.3357L0.214355 22.2143L18.6537 3.77501L3.72494 3.77507L3.72493 0.775069L23.775 0.774994Z"/></svg>') no-repeat center / contain;
}
.contain {
  background-color: var(--surface);
  width: 100%;
  max-width: 560px;
  border-radius: 8px;
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  text-decoration: none;
}
.contain:hover {
  text-decoration: none;
}
.visual {
  max-width: 100px;
  max-height: 80px;
  display: flex;
  background-color: var(--surface-2);
  justify-content: center;
  align-items: center;
  padding: 15px;
}
.logo {
  max-width: 70px;
}
.content {
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.content .title {
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 120%;
  color: var(--text);
  padding: 0;
  margin: 0;
}

.content .subtitle {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 150%;
  color: var(--text);
  padding: 0;
  margin: 0;
}

@media only screen and (max-width: 600px) {
  .wordlike * .subtitle {
    font-size: 10px;
  }

  .pop .content .subtitle {
    display: none;
  }
}

@media only screen and (max-width: 400px) {
  .visual {
    max-width: 80px;
  }
  .content .title {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sponsor.vue